import { safeHref } from '@nu/shared';

// Shows a rich-text document from the editor (ProseMirror JSON) as React
// elements: text only ever goes in as text, and links only to web, email or
// phone addresses, so a message can't carry markup or scripts.
export default function RichDoc({ doc }) {
  return <div className="rich">{(doc?.content || []).map((n, i) => <Node key={i} n={n} />)}</div>;
}

const kids = (n) => (n.content || []).map((c, i) => <Node key={i} n={c} />);

function Node({ n }) {
  switch (n.type) {
    case 'paragraph': return <p>{n.content?.length ? kids(n) : <br />}</p>;
    case 'heading': return n.attrs?.level === 3 ? <h4>{kids(n)}</h4> : <h3>{kids(n)}</h3>;
    case 'bulletList': return <ul>{kids(n)}</ul>;
    case 'orderedList': return <ol start={n.attrs?.start > 1 ? n.attrs.start : undefined}>{kids(n)}</ol>;
    case 'listItem': return <li>{kids(n)}</li>;
    case 'blockquote': return <blockquote>{kids(n)}</blockquote>;
    case 'horizontalRule': return <hr />;
    case 'hardBreak': return <br />;
    case 'table': return <div className="table-scroll rich-table"><table className="table"><tbody>{kids(n)}</tbody></table></div>;
    case 'tableRow': return <tr>{kids(n)}</tr>;
    case 'tableHeader': return <th>{kids(n)}</th>;
    case 'tableCell': return <td>{kids(n)}</td>;
    case 'text': return <Text n={n} />;
    default: return null;
  }
}

function Text({ n }) {
  let out = n.text;
  for (const m of n.marks || []) {
    if (m.type === 'bold') out = <strong>{out}</strong>;
    else if (m.type === 'italic') out = <em>{out}</em>;
    else if (m.type === 'underline') out = <u>{out}</u>;
    else if (m.type === 'strike') out = <s>{out}</s>;
    else if (m.type === 'link') {
      const href = safeHref(m.attrs?.href);
      if (href) out = <a href={href} target="_blank" rel="noopener noreferrer">{out}</a>;
    }
  }
  return out;
}
